import { marqueeItems } from "@/mocks/home";

export default function FlashTicker() {
  const items = [...marqueeItems, ...marqueeItems];

  return (
    <section className="w-full bg-foreground-950">
      <div className="w-full flex items-stretch">
        <div className="flex items-center gap-2 bg-primary-500 text-background-50 px-4 md:px-6 py-3 shrink-0">
          <i className="ri-flashlight-fill text-base"></i>
          <span className="text-sm font-medium whitespace-nowrap">最新快讯</span>
        </div>
        <div className="flex-1 overflow-hidden flex items-center">
          <div className="marquee-track flex items-center gap-8 md:gap-12 w-max pl-6">
            {items.map((text, i) => (
              <span key={i} className="text-sm text-background-200 whitespace-nowrap inline-flex items-center gap-3">
                <span className="w-1 h-1 rounded-full bg-accent-400"></span>
                {text}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}